<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">{{ title }}</h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="updateUserRoleForm"
      class="d-flex flex-row flex-wrap justify-content-around"
    >
      <mat-form-field
        *ngIf="forGlobalAdminOrReader == false"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>User Role</mat-label>
        <mat-select formControlName="userRole">
          <mat-option *ngFor="let type of types" [value]="type.value">{{
            type.name
          }}</mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('userRole').touched &&
            updateUserRoleForm.get('userRole').errors?.required
          "
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field
        *ngIf="forGlobalAdminOrReader == false"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Node Group</mat-label>
        <mat-select
          formControlName="nodeGroup"
          [(ngModel)]="alreadyAttachedNodeGroups"
          multiple
        >
          <mat-option
            type="checkbox"
            *ngFor="let node of groups"
            [value]="node"
            >{{ node }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('nodeGroup').touched &&
            updateUserRoleForm.get('nodeGroup').errors
          "
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == true && !isGroupsAccessControl"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Map Workstation</mat-label>
        <mat-select
          formControlName="mapWorkstation"
          [(ngModel)]="alreadyMappedWorkstation"
        >
          <mat-option value="NA" matTooltip="Select 'NA' to unmap workstation"
            >NA</mat-option
          >
          <mat-option
            type="checkbox"
            *ngFor="let ws of nodesData"
            [value]="ws.vmName"
            >{{ ws.vmName }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('mapWorkstation').touched &&
            updateUserRoleForm.get('mapWorkstation').errors
          "
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && forGlobalAdminOrReader == false"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Select Job Directory Path</mat-label>
        <mat-select
          formControlName="jobDirectoryPath"
          [(ngModel)]="jobSelectedPath"
        >
          <mat-option
            value="0"
            matTooltip="Select 'Default' to for default work directory"
            >Default</mat-option
          >
          <mat-option
            *ngFor="let option of jobPathOptions"
            [value]="option.jobValue"
            >{{ option.jobPath }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('mapWorkstation').touched &&
            updateUserRoleForm.get('mapWorkstation').errors
          "
          >Required</mat-error
        >
      </mat-form-field>

      <mat-form-field
        *ngIf="isVdi == false"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Job Priority</mat-label>
        <mat-select formControlName="jobPriority">
          <mat-option *ngFor="let jp of jobPriorities" [value]="jp">{{
            jp
          }}</mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('jobPriority').touched &&
            updateUserRoleForm.get('jobPriority').errors
          "
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && forGlobalAdminOrReader == false"
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Allocated Core Quota</mat-label>
        <input
          matInput
          placeholder="Allocated Cores"
          formControlName="editAllocatedCoreQuota"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          matTooltip="Enter '-1' for Unlimited Cores"
          matTooltipPosition="above"
          [matTooltipShowDelay]="500"
          style="color: var(--s-primary-color) !important; border: none"
        >
          <mat-icon>info</mat-icon>
        </button>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('editAllocatedCoreQuota').errors?.pattern
          "
          >Enter zero, positive number or -1</mat-error
        >
        <mat-error
          *ngIf="updateUserRoleForm.get('editAllocatedCoreQuota').errors?.max"
        >
          Value of allocated Cores exceeds total no. of cores available in the
          cluster.
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && !data.userInfo.fromUserGroup"
        style="width: 45%"
      >
        <mat-label>Job Submit Username</mat-label>
        <input
          matInput
          placeholder="Job Submit Username"
          formControlName="jobSubmitUserId"
          title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -"
        />
        <mat-error
          *ngIf="
            updateUserRoleForm.get('jobSubmitUserId').touched &&
            updateUserRoleForm.get('jobSubmitUserId').errors?.required
          "
        >
          Job submit user id cannot be empty.
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && !data.userInfo.fromUserGroup"
        style="width: 45%"
        appearance="fill"
      >
        <mat-label>Max Jobs</mat-label>
        <input
          matInput
          placeholder="Max Jobs"
          formControlName="maxJobs"
          type="number"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          matTooltip="Maximum jobs that can run simultaneously, New jobs will queue if limit is reached. Set -1 to Reset"
          matTooltipPosition="above"
          [matTooltipShowDelay]="500"
          style="color: var(--s-primary-color) !important; border: none"
        >
          <mat-icon>info</mat-icon>
        </button>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('maxJobs').touched &&
            updateUserRoleForm.get('maxJobs').errors?.required
          "
        >
          Max Jobs is required.
        </mat-error>
        <mat-error *ngIf="updateUserRoleForm.get('maxJobs').errors?.pattern">
          Max Jobs value must be either -1 or a positive number
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && !data.userInfo.fromUserGroup"
        style="width: 45%"
        appearance="fill"
      >
        <mat-label>Max Submit Jobs</mat-label>
        <input
          matInput
          placeholder="Max Submit Jobs"
          formControlName="maxSubmitJobs"
          type="number"
        />
        <button
          type="button"
          mat-icon-button
          matSuffix
          matTooltip="Maximum jobs that can be submitted at once, New submissions are denied if limit is reached. Set -1 to Reset"
          matTooltipPosition="above"
          [matTooltipShowDelay]="500"
          style="color: var(--s-primary-color) !important; border: none"
        >
          <mat-icon>info</mat-icon>
        </button>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('maxSubmitJobs').touched &&
            updateUserRoleForm.get('maxSubmitJobs').errors?.required
          "
        >
          Max Submit Jobs is required.
        </mat-error>
        <mat-error
          *ngIf="updateUserRoleForm.get('maxSubmitJobs').errors?.pattern"
        >
          Max Submit Jobs value must be either -1 or a positive number
        </mat-error>
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && forGlobalAdminOrReader == false"
        style="width: 45%"
        appearance="fill"
      >
        <mat-label>Update User Application Access</mat-label>
        <mat-select formControlName="updateApp" multiple>
          <mat-option *ngFor="let app of appList" [value]="app.uniqueId"
            >{{ app.appName }} {{ app.appVersion }}</mat-option
          >
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="
          isVdi == false &&
          !isGroupsAccessControl &&
          forGlobalAdminOrReader == false
        "
        appearance="fill"
        style="width: 45%"
      >
        <mat-label>Update User Storage Access</mat-label>
        <mat-select
          formControlName="updateStorage"
          [(ngModel)]="assignedStorages"
        >
          <mat-option
            value="Default"
            matTooltip="Select 'Default' to for all storages"
            >Default</mat-option
          >
          <mat-option *ngFor="let storage of storageList" [value]="storage">{{
            storage
          }}</mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            updateUserRoleForm.get('updateStorage').touched &&
            updateUserRoleForm.get('updateStorage').errors
          "
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == false && getAppList()?.length > 0"
        style="width: 45%"
        appearance="fill"
      >
        <mat-label>Update User App License</mat-label>
        <mat-select formControlName="selectedAppLicense" multiple>
          <mat-optgroup
            *ngFor="let app of getAppList()"
            [label]="app.appName + ' ' + app.appVersion"
          >
            <mat-option
              *ngFor="let lic of app.avlLicenses"
              [value]="app.appName + ':' + app.appVersion + ':' + lic"
              [disabled]="isOptionDisabled(app, lic)"
            >
              {{ lic }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="isVdi == true && !isGroupsAccessControl"
        style="width: 45%"
      >
        <mat-label>Session Request-Connect Username</mat-label>
        <input
          matInput
          placeholder="Session Request-Connect Username"
          formControlName="sessionUserIdForGAReader"
          title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -"
        />
        <mat-error
          *ngIf="
            updateUserRoleForm.get('sessionUserIdForGAReader').touched &&
            updateUserRoleForm.get('sessionUserIdForGAReader').errors?.required
          "
        >
          Session user id cannot be empty.
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="updateUserRoleForm.status == 'INVALID'"
      (click)="onSubmit(updateUserRoleForm)"
    >
      Update
    </button>
  </div>
</div>
